import { createElement, useMemo } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import * as LandingStatus from 'hb-react/frontoffice/apps/LiveFeed/constants/LandingStatus';
import IconEdit from 'hb-react/shared/icons/Edit';
import IconNotification from 'hb-react/shared/icons/Notification';

const StatusBar = ({ isActive }) => {
  const status = useMemo(() => {
    switch (isActive) {
      case LandingStatus.FROM_NOTIFICATIONS:
        return {
          text: __('From notifications'),
          icon: IconNotification,
        };
      case LandingStatus.JUST_CREATED:
        return {
          text: __('Just posted'),
          icon: IconEdit,
        };
      default:
        return null;
    }
  }, [isActive]);

  return status ? (
    <Box display="block">
      <Box mb={4} alignItems="center">
        <Box mr={2} height={24} width={24} color="primary">
          {createElement(status.icon, {
            height: '100%',
            width: '100%',
          })}
        </Box>
        <Box fontWeight={1} color="asphalt">
          {status?.text}
        </Box>
      </Box>
      <Box height={1} css="width: 100%;" bg="horizon" mb={4} />
    </Box>
  ) : null;
};

export default StatusBar;
